import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { CallStage } from 'src/app/enums/CallStage';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-report-company',
  templateUrl: './report-company.component.html',
  styleUrls: ['./report-company.component.scss']
})
export class ReportCompanyComponent implements OnInit {

  talentfilterdata: any = {};
  totalResultCount: number;
  start: number = 0;
  end: number = 10;
  currentCompanyData: any = []
  currentcompanies:any;
  @ViewChild('companysort') companysort: MatSort;
  displayedColumns: string[] = ['key', 'doc_count', 'attrition', 'oneyeargrowth', 'percentage', 'graph'];
  aggregatescount: number = 50;
  totalCount: number = 0;

  isApiCalled:boolean = false;
  currentPage: number = 1;
  pageSize: number = 10;
  companyarray:any[] = [];

  subscriptions: Array<Subscription> = [];

  /**Sorted data for all intital pages */
  comapniesSortData:any;
  /**Attrition data called or or not*/
  hasAttritionData:boolean = false;
  /** Diversity data called or not*/
  hasDiversityData = false;
  hasoneyeargrowth:boolean = false;
  companydataAI: any

  insightsExportSubscription: Subscription = null;
  primaryCompanyInformation:any = {};

  get isLocationEurope() {
    return this.localstorageservice.getItem('talentRegion') == 'europe';
  }

  constructor(private personsearchservice: PersonSearchService, private localstorageservice: LocalStorageService, private router: Router
    , private talentInsightsReqHandlerService: TalentInsightsReqHandlerService, private aggReqObjectHandlerService: AggReqObjectHandlerService
    , private filterDataHandlerService: FilterDataHandlerService, private aggService: AggregationService, private talentInsightsService: TalentInsightsService
    , private hashService: HashService) { }

  ngOnInit() {
    this.setUpdatedData();
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.setUpdatedData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) { 
      this.talentfilterdata = talentFilterData;
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.getcurrentcompany();
    this.personsearchservice.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)

  }

  getcurrentcompany() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_company';
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq).subscribe((response) => {
      this.isApiCalled = true;
      this.totalResultCount = response.data.totalresultscount;

      const tempData = response.data.aggregations.current_company;
      this.companyarray = _.pluck(tempData, 'key')
      this.comapniesSortData = tempData;
      this.totalCount = tempData.length;
      this.currentCompanyData = tempData.slice(this.start, this.end);
      this.currentcompanies = new MatTableDataSource(this.currentCompanyData);
      this.currentcompanies.sort = this.companysort;
      this.hasDiversityData = false;
      this.hasAttritionData = false;
      this.hasoneyeargrowth = false;

      this.getcurrentcompanydiversity();
      this.getrecentattrition();
      this.getoneyeargrowth()
      this.manualSort();

    });
  }

  getCurrentcompanypercentage(value) {
    return ((value / this.totalResultCount) * 100).toFixed(2);
  }

  getdiversitypercentage(value, doc_count) {
    return ((value / doc_count) * 100).toFixed(0);
  }

  manualSort() {
    this.reSortArr(this.companysort);
  }

  reSortArr(sort){
    const tempData = this.comapniesSortData;
    if(!sort || !sort.active || sort.direction === ''){
      this.currentCompanyData = tempData.slice(this.start, this.end);
      this.currentcompanies = new MatTableDataSource(this.currentCompanyData);
      this.currentcompanies.sort = this.companysort;
      return;
    }
    this.comapniesSortData = tempData.sort((a,b)=>{
      const isAsc = sort.direction === 'asc';
      switch(sort.active){
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'attrition' : return this.compare(a.attrition,b.attrition, isAsc);
        case 'percentage': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'graph' : return this.compare(a.male,b.male, isAsc);
        case 'oneyeargrowth' : return this.compare(a.oneyeargrowth,b.oneyeargrowth, isAsc);

      }
    })

    this.currentCompanyData = tempData.slice(this.start, this.end);
    this.currentcompanies = new MatTableDataSource(this.currentCompanyData);
    this.currentcompanies.sort = this.companysort;
  }

  compare(a:number, b:number, isAsc: boolean){
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if(this.aggregatescount / this.pageSize <= index){
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getcurrentcompany();
    }
    else{
      this.manualSort();
    } 
  }

  getcurrentcompanydiversity() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_company-gender';
    aggReq.searchviaboolean = true;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.companyarray;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq).subscribe((response) => {
    const tempData = response.data.aggregations['current_company-gender'];
    this.comapniesSortData.map(res=>{
      const gender = tempData.filter(x=>x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
      this.hasDiversityData = true;
      if(gender && gender.gender && gender.gender.length > 0) {
        const femalecount = gender.gender.filter(x=>x.key == "female") && gender.gender.filter(x=>x.key == "female").length > 0 ? gender.gender.filter(x=>x.key == "female")[0].doc_count: 0;
        const malecount = gender.gender.filter(x=>x.key == "male") && gender.gender.filter(x=>x.key == "male").length > 0 ? gender.gender.filter(x=>x.key == "male")[0].doc_count: 0;
        const totalgendercount = femalecount + malecount
        res.female = femalecount ? (this.getdiversitypercentage(femalecount, totalgendercount)): 0

        res.male = malecount ? this.getdiversitypercentage(malecount, totalgendercount): 0;
      
      }
      return res;
    })
    this.getcompanydataai(this.comapniesSortData)
      
    });
  }

  getrecentattrition() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'lastcompany';
    aggReq.searchviaboolean = true;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.companyarray;
    aggReq.companytype = 'Past';
    aggReq.recentcompanyattrition = true;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations.lastcompany;
      this.hasAttritionData = true
      this.comapniesSortData.map(res=>{
        const pastcompany = tempData.filter(x=>x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
        res.attrition = pastcompany && pastcompany.doc_count ? pastcompany.doc_count: 0;
        return res;
      })
      this.getcompanydataai(this.comapniesSortData)
      //  this.totalCount = this.totalResultCount;
      //  this.currentCompanyData = tempData;
      //  this.currentcompanies = new MatTableDataSource(this.currentCompanyData);
      //  this.currentcompanies.sort = this.companysort;
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getoneyeargrowth() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_company';
    aggReq.searchviaboolean = true;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.companyarray;
    aggReq.companytype = 'Current';
    aggReq.recentcompanyhires = true;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations.current_company;
      this.hasoneyeargrowth = true;
      this.comapniesSortData.map(res=>{
        const currentcompany = tempData.filter(x=>x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
        res.oneyeargrowth = currentcompany && currentcompany.doc_count ? currentcompany.doc_count: 0;
        return res;
      })
      this.getcompanydataai(this.comapniesSortData)
      //  this.totalCount = this.totalResultCount;
      //  this.currentCompanyData = tempData;
      //  this.currentcompanies = new MatTableDataSource(this.currentCompanyData);
      //  this.currentcompanies.sort = this.companysort;
    });
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    if(this.isLocationEurope) return;

    const additionalFilters = {};
    switch(type) {
      case 'company': additionalFilters['mandatorycompanies'] = [key]; break;
      case 'recentcompanyhires': {
        additionalFilters['recentcompanyhires'] = true;
        additionalFilters['mandatorycompanies'] = [key];
        break;
      }
      case 'recentcompanyattrition': {
        additionalFilters['recentcompanyattrition'] = true;
        additionalFilters['mandatorycompanies'] = [key];
        break;
      }
    }

    this.talentfilterdata['additionalFilters'] = additionalFilters;
    // this.localstorageservice.setItem('talentfilters', JSON.stringify(this.talentfilterdata));
    // this.personsearchservice.setTalentinsights(this.talentfilterdata);
    // this.router.navigate(['/person/search/listing'], { queryParams: { 'redirectSource': 'talent-insights' } })
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCurrentRedirection(uniqueHash, this.talentfilterdata);
    const aggReq = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=talent-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${uniqueHash}&keyword=${aggReq.booleanquery!= '*' ? aggReq.booleanquery: ''}`; 
    window.open(url, "_blank");
  }

  getcompanydataai(data) {
    let companiesdata: any;
    companiesdata = data.map(x=>{
    let res: any ={};
    res['Top Companies'] = x.key;
    res['Talent Count'] = x.doc_count;
    res['1 yr Attrition'] = x.attrition;
    res['1 yr Growth'] = x.oneyeargrowth;
    res['% of Total'] = this.getCurrentcompanypercentage(x.doc_count)+'%';
    res['Male'] = x.male+'%';
    res['Female'] = x.female+'%';
    return res;
  })
  this.companydataAI = {
    companies: companiesdata
  }
  if(companiesdata.length == 0)
    this.companydataAI = null;
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if(requestData?.data?.currentTab !== 'company') return;

    const payloadForInsightsExport = {
      tab: 'company',
      totalresultcount: this.totalResultCount,
      companies: this.comapniesSortData
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  getCompanyInfo(companyname){
    let companyData = {}
    companyData = {
      companynames: [companyname]
    }
    this.personsearchservice.getCompanyLogo(companyData).subscribe((res: any) => {
      if(res.status == 'success' && res.message){
        let companyDetails = res.message[0]        
        this.primaryCompanyInformation['website'] = companyDetails.website ? companyDetails.website : null;
        this.primaryCompanyInformation['name'] = companyDetails.name ? companyDetails.name : null;
        this.primaryCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : null;
        this.primaryCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : null;
        this.primaryCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : null;
        this.primaryCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : null;
        this.primaryCompanyInformation['companylogo'] = res.message[0].companylogo
        this.primaryCompanyInformation['id'] = res.message[0].id
        this.primaryCompanyInformation['companylogo'] = res.message[0].companylogo
        this.primaryCompanyInformation['key_id'] = res.message[0].id  

      }
    });
  }

}
